(function () {
    'use strict';

    angular
        .module('travelExpenses')
        .controller('DailyAllowanceDeleteModalController', DailyAllowanceDeleteModalController);

        DailyAllowanceDeleteModalController.$inject = ['$uibModalInstance', 'item', 'TravelExpenseService', 'toastr', 'dailyAllowanceController'];

    function DailyAllowanceDeleteModalController($uibModalInstance, item, TravelExpenseService, toastr, dailyAllowanceController) {

        var vm = this;
        vm.item = item;
        vm.ok = ok;
        vm.cancel = cancel;

        activate();

        function activate() {
        }

        function ok () {
            let query = {};
            query['id'] = vm.item.id;
            TravelExpenseService.deleteDailyAllowance(query).then(function(response) {
                if(response.status !== 200) {
                    toastr.error("Error on delete daily allowance");
                } else {
                    toastr.success("Daily allowance successfully deleted");
                    dailyAllowanceController.getByFilter();
                }
                $uibModalInstance.close();
            }).catch(function(err) {
                toastr.error('Error:'+err);
            });
        }

        function cancel () {
            $uibModalInstance.close();
        }
    }
})();